import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure,
    resetState
} from './permissions.action';
import * as PermissionActions  from './permissions.action';
import { Permission } from './permissions.model';
import { Role } from '../Roles/roles.model';

export interface PermissionRecordsState {
    listData: Permission[];
    role: Role;
    loading: boolean;
    error: any;
}

export const initialState: PermissionRecordsState = {
    listData: [],
    role: null,
    loading: false,
    error: null,
};


export const permissionRecordReducer = createReducer(
    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, role }) => {
        return { ...state, listData: listData, role: role, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),
    on(resetState, () => initialState)  // Reset action handler
);